import { formatValue } from '../../../../utils/managerUtils';
import { isDetailValueWide } from './isDetailValueWide';

export type DetailItem = {
  column: any;
  value: string;
  wide: boolean;
};

export const getDetailItems = (data: any, detailColumns: any): DetailItem[] =>
  data
    ? detailColumns.map((column: any) => {
        const value: string = String(formatValue(data, column, true));
        return { column, value, wide: isDetailValueWide(value) };
      })
    : [];
